import type { DomainQuerySchema } from '../schemas';

export const fieldNames: Record<keyof DomainQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: true },
  name: { name: 'Domain Name', revertible: true },
  dns_management: { name: 'DNS Management', revertible: true },
  deployment_path: { name: 'Deployment Path', revertible: true },
  hosting_management: { name: 'Hosting Management', revertible: true },
  registrar_management: { name: 'Registrar Management', revertible: true },
  expiration_date: { name: 'Domain Expiration', revertible: true },
  registrar_notes: { name: 'Registrar Notes', revertible: true },
  hosting_notes: { name: 'Hosting Notes', revertible: true },
  registrar_username: { name: 'Registrar Username', revertible: true },
  registrar_password: { name: 'Registrar Password', revertible: true },
  registrar_pin: { name: 'Registrar Pin', revertible: true },
  registrar: { name: 'Domain Registrar', revertible: true },
  infrastructure: { name: 'Infrastructure', revertible: true },
  client: { name: 'Company', revertible: true },
  application: { name: 'Application', revertible: true },
  created_by: { name: 'Created By', revertible: true },

  creator_id: { name: 'Creator ID', revertible: false },
  application_id: { name: 'Application ID', revertible: false },
  client_id: { name: 'Company ID', revertible: false },
  infrastructure_id: { name: 'Infrastructure ID', revertible: false },
  registrar_id: { name: 'Registrar ID', revertible: false },
};
